window.addEventListener('query-text-changed', ($event) => {
  const breadcrumbsItems = document.getElementsByClassName(
    'js-breadcrumbs-item'
  )
  if (!breadcrumbsItems.length) return

  const { query, nbHits } = $event.detail

  const text = `検索結果${query ? `"${query}"` : ''} (${nbHits}件)`

  const index = Array.from(breadcrumbsItems)
    .map((item) => !!item.innerText.match(/検索結果/))
    .indexOf(true)
  const isItemLast = index === breadcrumbsItems.length - 1
  const element = document.createElement(isItemLast ? 'span' : 'a')
  if (isItemLast) {
    element.classList.add('sn-breadcrumbs-band__last')
  } else {
    const href = `/search${query ? `?q=${query}` : ''}`
    element.setAttribute('href', href)
    element.classList.add('sn-breadcrumbs-band__link')
  }
  const textNode = document.createTextNode(text)
  element.appendChild(textNode)
  breadcrumbsItems[index].innerHTML = null
  breadcrumbsItems[index].appendChild(element)
})
